import { Navigate } from "react-router-dom";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const FeeIndexPage: React.FC = () => {
  const { fundFamilyId } = useRequiredStringParams();

  return (
    <Navigate
      replace={true}
      to={
        rootRoute({})
          .fundFamilies({})
          .fundFamily({ fundFamilyId })
          .fees({})
          .dashboard({}).$
      }
    />
  );
};
